import React from "react"
import { useTranslation } from "react-i18next"

import { Layout } from "~/components/Layout/Layout"

import { Content } from "./components/Content"

const ResponsibleInvestment: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout headerTheme="onLight" title={t("page.responsible-investment-principles")}>
      <Content />
    </Layout>
  )
}

export default ResponsibleInvestment
